export const isAutumnSeasonCampaignActive = (): boolean => {
  const currentTime = new Date().getTime();
  const campaignStartDate = new Date('2025-09-01');

  campaignStartDate.setHours(0, 0, 0, 0);

  return currentTime >= campaignStartDate.getTime();
};

export const isSummerSeasonCampaignActive = (): boolean => {
  const currentTime = new Date().getTime();
  const campaignStartDate = new Date('2025-06-05');
  const campaignEndDate = new Date('2025-08-31');

  campaignStartDate.setHours(0, 0, 0, 0);
  campaignEndDate.setHours(23, 59, 59, 999);

  return currentTime >= campaignStartDate.getTime() && currentTime <= campaignEndDate.getTime();
};
